import { Logo } from "@/components/Reveal";
import { Link } from "react-router-dom";
import { scrollToSection } from "@/lib/smoothScroll";
import { useLang } from "@/context/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t border-slate-800/70 bg-[#070A10]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 flex flex-col sm:flex-row items-center justify-between gap-8">
        <Logo />
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-[11px] uppercase tracking-[0.2em] text-slate-400">
          {[["#chi-sono", t("nav.chiSono")], ["#percorso", t("nav.percorso")], ["#risultati", t("nav.risultati")], ["#news", t("nav.news")], ["#gallery", t("nav.gallery")], ["#contatti", t("nav.contatti")]].map(([h, l]) => (
            <button key={h} onClick={() => scrollToSection(h)} className="hover:text-amber-400 transition-colors">{l}</button>
          ))}
        </div>
        <Link
          to="/admin"
          data-testid="footer-admin-link"
          className="text-[10px] uppercase tracking-[0.25em] text-slate-600 hover:text-slate-300 transition-colors"
        >
          {t("footer.admin")}
        </Link>
      </div>
      <div className="border-t border-slate-800/50 py-5 text-center text-xs text-slate-600">
        © {new Date().getFullYear()} Giacomo Bertagnolli — {t("footer.rights")}
      </div>
    </footer>
  );
}
